import { render, staticRenderFns } from "./RelationStateBadge.vue?vue&type=template&id=ad3c5a6c&scoped=true&"
import script from "./RelationStateBadge.vue?vue&type=script&lang=ts&"
export * from "./RelationStateBadge.vue?vue&type=script&lang=ts&"
import style0 from "./RelationStateBadge.vue?vue&type=style&index=0&id=ad3c5a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3c5a6c",
  null
  
)

export default component.exports